// Minimal hash router with lazy module loading and cleanup on navigation.

import { state, subscribe } from './state.js';

const routes = new Map();
let currentCleanup = null;

export function register(name, loader) {
  routes.set(name, loader);
}

export async function navigate(name, params = {}) {
  if (typeof currentCleanup === 'function') {
    try { currentCleanup(); } catch (e) { console.warn('[router] cleanup error', e); }
    currentCleanup = null;
  }

  const loader = routes.get(name);
  if (!loader) {
    console.warn(`[router] route not found: ${name}`);
    return;
  }

  state.currentScreen = name;
  try {
    const mod = await loader();
    if (typeof mod.mount === 'function') {
      const cleanup = await mod.mount(params);
      if (typeof cleanup === 'function') currentCleanup = cleanup;
    }
  } catch (e) {
    console.error(`[router] failed to load ${name}`, e);
  }
}

export function start(defaultRoute = 'auth') {
  const handler = () => {
    const hash = window.location.hash.replace(/^#\/?/, '');
    const [name, ...rest] = hash.split('/');
    const params = Object.fromEntries(rest.map((p, i) => [`p${i}`, p]));
    navigate(name || defaultRoute, params);
  };
  window.addEventListener('hashchange', handler);
  handler();
}

// Legacy shim — show/hide DOM screens by id (used during migration)
export function showScreen(id) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  const el = document.getElementById(id);
  if (el) el.classList.add('active');
  state.currentScreen = id;
}

if (typeof window !== 'undefined') {
  window.navigate = navigate;
  window.showScreen = showScreen;
}
